import api from './Api';
const base = '/api/v1/customer/reviews';
export const reviewApi = {
    mine: (page = 1, productId) => api.get(base, {params:{page, ...(productId ? {product_id:productId} : {})}}),
    eligible: (page = 1, productId) => api.get(`${base}/eligible`, {params:{page, ...(productId ? {product_id:productId} : {})}}),
    create: data => api.post(base, data),
    update: (id, data) => api.put(`${base}/${id}`, data),
    remove: id => api.delete(`${base}/${id}`),
    publicList: (slug, params = {}) => api.get(`/api/v1/storefront/products/${encodeURIComponent(slug)}/reviews`, {params:{...params, ...(localStorage.getItem('country_id') ? {country_id:localStorage.getItem('country_id')} : {})}}),
};
